import React, { Component } from "react";
import Checkbox from "./Checkbox";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createLeagues } from '../shared/CreateLeagues';
import * as actions from '../../redux/actions/leagues';

class Leagues extends Component {

    OPTIONS = createLeagues(this.props.lastMatches);

    state = {
        checkboxes: this.OPTIONS.reduce(
            (options, option) => ({
                ...options,
                [option]: this.props.isFirstRender ? true : (this.props.selectedLeagues.includes(option))
            }),
            {}
        )
    };

    selectAllCheckboxes = isSelected => {
        Object.keys(this.state.checkboxes).forEach(checkbox => {
            this.setState(prevState => ({
                checkboxes: {
                    ...prevState.checkboxes,
                    [checkbox]: isSelected
                }
            }));
        });
    };

    selectAll = () => this.selectAllCheckboxes(true);

    deselectAll = () => this.selectAllCheckboxes(false);

    handleCheckboxChange = changeEvent => {
        const { name } = changeEvent.target;

        this.setState(prevState => ({
            checkboxes: {
                ...prevState.checkboxes,
                [name]: !prevState.checkboxes[name]
            }
        }));
    };

    handleFormSubmit = formSubmitEvent => {
        formSubmitEvent.preventDefault();
        let selected = [];
        Object.keys(this.state.checkboxes)
            .filter(checkbox => this.state.checkboxes[checkbox])
            .forEach(checkbox => {
                selected.push(checkbox);
                console.log(checkbox, "is selected.");
            });
        this.props.onSelect(selected);
        this.props.history.push("/matches");
    };

    createCheckbox = option => (
        <div style={{ width: '50%' }}>
            <Checkbox
                label={option}
                isSelected={this.state.checkboxes[option]}
                onCheckboxChange={this.handleCheckboxChange}
                key={option}
            />
        </div>
    );

    createCheckboxes = () => this.OPTIONS.map(this.createCheckbox);

    styles = {
        CheckboxGroup: {
            display: 'flex',
            flexWrap: 'wrap',
            width: window.innerWidth < 500 ? '100%' : '500px',
            padding: '5px',
        }
    }

    render() {
        return (
            <div className="custom-container" >
                <div className="row mt-5">
                    <div className="col-sm-12 p-5" style={{ background: ' #424242' }}>
                        <form onSubmit={this.handleFormSubmit}>
                            <div style={this.styles.CheckboxGroup}>
                                {this.createCheckboxes()}
                            </div>

                            <div className="form-group mt-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary mr-2"
                                    onClick={this.selectAll}
                                >
                                    Select All
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary mr-2"
                                    onClick={this.deselectAll}
                                >
                                    Deselect All
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    Ok
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        lastMatches: state.matches.matches,
        selectedLeagues: state.leagues.selectedLeagues,
        isFirstRender: state.leagues.isFirstRender,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelect: (leagues) => dispatch(actions.setSelectedLeagues(leagues))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Leagues));

